import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  makeStyles,
  Typography,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
  FormControlLabel,
  Switch,
  Grid,
} from "@material-ui/core";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import {
  apiEndpoints,
  apiGetByIdRequest,
  apiPutRequest,
  apiDeleteRequest,
  apiPostRequest,
} from "src/utils/api/api";
import { useParams } from "react-router";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import actions from "src/duck/document/actions";
import { useNavigate } from "react-router-dom";
import globalActions from "src/duck/global/actions";
import KmFilteredDocumentsTable from "src/components/document/KmFilteredDocumentsTable";
import { addCreatedUpdatedPublishedArchivedFields } from "src/utils/utils";
import { userHasAtLeastOnePermission } from "src/utils/userutils";
import DocumentStructName from "src/components/document/DocumentStructName";
import { Search as SearchIcon } from "react-feather";
import KmDocumentList from "src/components/common/KmDocumentList";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import { kmMessages } from "src/constant/Messages";
import { encode } from "js-base64";
import KmPageTitle from "src/components/layout/KmPageTitle";
import { useMountedState } from "react-use";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    flexGrow: 1,
  },
  toolbaruser: {
    marginTop: theme.spacing(1),
  },
}));

const RowButtons = (row, customHandlers, ...rest) => {
  const navigateOptionallyTo = (mainPartUrl) => {

    let redirectUrl = customHandlers?.siblingId ? `/${mainPartUrl}/${row.id}/${customHandlers.siblingId}/${encode(
      customHandlers.siblingName,
      true
    )}` : `/${mainPartUrl}/${row.id}`

    if (customHandlers?.workGroupsIds) {
      redirectUrl += `?workGroupsIds=${customHandlers.workGroupsIds}`;
    }  else if (customHandlers.isRootLevel){
      redirectUrl += `?rootLevel=true`;
    }

    return redirectUrl;
  };

  return customHandlers.isAuthorized && customHandlers.permissionsChecked ? (
    <Box>
      <Tooltip title="Edytuj">
        <IconButton
          aria-label="edytuj"
          component={RouterLink}
          to={
            row.nodeType === "2"
              ? navigateOptionallyTo("edytujdokument")
              : row.nodeType === "1"
              ? navigateOptionallyTo("edytujkatalog")
              : `/`
          }
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    </Box>
  ) : (
    <></>
  );
};

const DocumentStructRowName = (
  row,
  customHandlers,
  markVotingsTable,
  ...rest
) => {
  // console.log(markVotingsTable);
  return (
    <DocumentStructName
      document={row}
      openDocumentHandler={customHandlers.handleOpenDocument}
      markVotings={markVotingsTable}
    />
  );
};

const StatusCell = (row, customHandlers, ...rest) => {
  const dataLabels = { draft: "Wersja robocza", published: "Opublikowany" };
  return (
    <>
      <Typography variant="body2">{dataLabels[row.status]}</Typography>
      <Typography variant="caption">
        {row.publicAccess ? "(publiczny)" : "(po zalogowaniu)"}
      </Typography>
    </>
  );
};

const DocumentListView = ({
  globalData,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  hideSnackbar,
  setRedirectPath,
  setLogoutUser,
}) => {
  const classes = useStyles();
  const [documents, setDocuments] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedDocumentIds, setSelectedDocumentIds] = useState([]);
  const { folderId, votingId } = useParams();
  const [dialogOpen, setOpen] = useState(false);
  const [dialogPublishOpen, setPublishOpen] = useState(false);
  const [dialogUnpublishOpen, setUnpublishOpen] = useState(false);
  const [dialogSetPublicAccessOpen, setSetPublicAccessOpen] = useState(false);
  const [dialogUnsetPublicAccessOpen, setUnsetPublicAccessOpen] = useState(
    false
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [levelDetails, setLevelDetails] = useState({});
  const [searchText, setSearchText] = useState("");
  const [searchTextInternal, setSearchTextInternal] = useState("");
  const [allDocumentsSearch, setAllDocumentsSearch] = React.useState(false);
  const [contentSearch, setContentSearch] = React.useState(false);
  const [foundDocuments, setFoundDocuments] = useState([]);
  const [documentId, setDocumentId] = useState(null);
  const [votingDetails, setVotingDetails] = useState(null);

  const sourcePath = window.location.pathname;

  const isMounted = useMountedState();

  const handleOpenDocument = (event, documentId) => {
    event.preventDefault();
    navigate("/dokumenty/dokument/" + documentId);
  };

  const getSelectedDocumentName = (selectedId) => {
    let document = documents.filter((doc) => {
      return doc.id === selectedId;
    });

    return document?.length > 0 ? document[0].name : null;
  };

  const getAllowedWorkGroups = () => {
    const lastItem = levelDetails.documentStructNodesBreadCrumps[levelDetails.documentStructNodesBreadCrumps.length - 1];
    const workGroupsIdsString = lastItem.workGroupsIds ? lastItem.workGroupsIds.join(',') : '';

    return workGroupsIdsString;
  };

  const isRootLevel = () => {
    return levelDetails.documentStructNodesBreadCrumps.length === 1;
  };

  const getSelectedDocuments = (selectedDocumentIds) => {
    if (selectedDocumentIds) {
      let selDocuments = documents.filter((doc) => {
        return (
          selectedDocumentIds.filter((docId) => docId === doc.id).length > 0
        );
      });

      return selDocuments;
    }
    return null;
  };

  const headCells = userHasAtLeastOnePermission(globalData, [
    "user_admin",
    "super_admin",
  ])
    ? [
        {
          id: "name",
          numeric: false,
          sortable: true,
          fieldName: "id",
          main: false,
          aria: true,
          label: "Nazwa",
          customHandlers: { handleOpenDocument },
          component: DocumentStructRowName,
          width: "50%",
        },
        {
          id: "status",
          numeric: false,
          disablePadding: false,
          fieldName: "status",
          sortable: true,
          main: false,
          label: "Status",
          component: StatusCell,
          width: "12%",
        },
        {
          id: "created",
          fieldName: "createdAt",
          fieldName2: "createdBy",
          kmUdField: true,
          numeric: false,
          disablePadding: false,
          sortable: true,
          searchable: true,
          label: "Kiedy i kto utworzył",
          width: "12%",
        },
        {
          id: "updated",
          fieldName: "updatedAt",
          fieldName2: "updatedBy",
          kmUdField: true,
          numeric: false,
          disablePadding: false,
          sortable: true,
          searchable: true,
          label: "Kiedy i kto zmodyfikował",
          width: "12%",
        },
        {
          id: "published",
          fieldName: "publishedAt",
          fieldName2: "publishedBy",
          kmUdField: true,
          numeric: false,
          disablePadding: false,
          sortable: true,
          searchable: true,
          label: "Kiedy i kto opublikował",
          width: "12%",
        },
        {
          id: "btns",
          kmUdField: false,
          numeric: false,
          disablePadding: false,
          searchable: false,
          sortable: false,
          customHandlers: {
            isAuthorized: globalData.currentUser.isAuthorized,
            permissionsChecked: userHasAtLeastOnePermission(globalData, [
              "user_admin",
              "super_admin",
            ]),
            siblingId:
              selectedDocumentIds?.length === 1 ? selectedDocumentIds[0] : null,
            siblingName:
              selectedDocumentIds?.length === 1
                ? getSelectedDocumentName(selectedDocumentIds[0])
                : null,
            workGroupsIds: levelDetails?.documentStructNodesBreadCrumps ? getAllowedWorkGroups() : null,
            isRootLevel: levelDetails?.documentStructNodesBreadCrumps ? isRootLevel() : false
          },
          component: RowButtons,
        },
      ]
    : [
        {
          id: "name",
          numeric: false,
          sortable: true,
          fieldName: "id",
          main: false,
          label: "Nazwa",
          customHandlers: { handleOpenDocument },
          component: DocumentStructRowName,
          width: "50%",
        },
        {
          id: "status",
          numeric: false,
          disablePadding: false,
          fieldName: "status",
          sortable: true,
          main: false,
          label: "Status",
          component: StatusCell,
          width: "12%",
        },
        {
          id: "published",
          fieldName: "publishedAt",
          fieldName2: "publishedBy",
          kmUdField: true,
          numeric: false,
          disablePadding: false,
          sortable: true,
          searchable: true,
          label: "Kiedy i kto opublikował",
          width: "12%",
        },
      ];

  const onSelectedDocumentIdsChanged = (viewSelectedDocumentIds) => {
    setSelectedDocumentIds(viewSelectedDocumentIds);
  };

  const handleClickOpen = () => {
    if (selectedDocumentIds?.length > 0) {
      let selectedVotings = getSelectedDocuments(selectedDocumentIds).filter(
        (moveSelectedDocument) => moveSelectedDocument?.votings?.length > 0
      );

      if (selectedVotings?.length > 0) {
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 3000,
          message:
          kmMessages.info.document.voting_delete,
        });
      } else {
        setOpen(true);
      }
    } else {
      displaySnackbar({
        isOpen: true,
        severity: "info",
        autoHideDuration: 3000,
        message: kmMessages.info.document.not_selected,
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    setOpen(false);
    enableGlobalLoader();

    apiDeleteRequest(
      apiEndpoints.deleteDocuments.path,
      selectedDocumentIds,
      true
    )
      .then((data) => {
        setReloadCounter(reloadCounter + 1);
        setSelectedDocumentIds([]);
        disableGlobalLoader();
      })
      .catch((error) => {
        disableGlobalLoader();
        navigate("/dokumenty");
      });
  };

  const handleClickOpenPublish = () => {
    if (selectedDocumentIds?.length > 0) {
      setPublishOpen(true);
    } else {
      displaySnackbar({
        isOpen: true,
        severity: "info",
        autoHideDuration: 3000,
        message: kmMessages.info.document.not_selected,
      });
    }
  };

  const handleClosePublish = () => {
    setPublishOpen(false);
  };

  const handlePublish = () => {
    setPublishOpen(false);
    enableGlobalLoader();
    apiPostRequest(
      apiEndpoints.setDocumentsStatus.path,
      {
        nodeIds: selectedDocumentIds,
        status: "published",
      },
      true
    )
      .then((data) => {
        setSelectedDocumentIds([]);
        setReloadCounter(reloadCounter + 1);
        disableGlobalLoader();
      })
      .catch((error) => {
        disableGlobalLoader();
        navigate("/dokumenty");
      });
  };

  const handleClickOpenUnpublish = () => {
    if (selectedDocumentIds?.length > 0) {
      setUnpublishOpen(true);
    } else {
      displaySnackbar({
        isOpen: true,
        severity: "info",
        autoHideDuration: 3000,
        message: kmMessages.info.document.not_selected,
      });
    }
  };

  const handleCloseUnpublish = () => {
    setUnpublishOpen(false);
  };

  const handleUnpublish = () => {
    setUnpublishOpen(false);
    enableGlobalLoader();
    apiPostRequest(
      apiEndpoints.setDocumentsStatus.path,
      {
        nodeIds: selectedDocumentIds,
        status: "draft",
      },
      true
    )
      .then((data) => {
        setSelectedDocumentIds([]);
        setReloadCounter(reloadCounter + 1);
        disableGlobalLoader();
      })
      .catch((error) => {
        disableGlobalLoader();
        navigate("/dokumenty");
      });
  };

  const handleClickOpenSetPublicAccess = () => {
    if (selectedDocumentIds?.length > 0) {
      setSetPublicAccessOpen(true);
    } else {
      displaySnackbar({
        isOpen: true,
        severity: "info",
        autoHideDuration: 3000,
        message: kmMessages.info.document.not_selected,
      });
    }
  };

  const handleCloseSetPublicAccess = () => {
    setSetPublicAccessOpen(false);
  };

  const handleSetPublicAccess = () => {
    setSetPublicAccessOpen(false);
    enableGlobalLoader();
    apiPostRequest(
      apiEndpoints.setDocumentsPublicAccess.path,
      {
        nodeIds: selectedDocumentIds,
        action: "set_public_access",
      },
      true
    )
      .then((data) => {
        setSelectedDocumentIds([]);
        setReloadCounter(reloadCounter + 1);
        disableGlobalLoader();
      })
      .catch((error) => {
        disableGlobalLoader();
        navigate("/dokumenty");
      });
  };

  const handleClickOpenUnsetPublicAccess = () => {
    if (selectedDocumentIds?.length > 0) {
      setUnsetPublicAccessOpen(true);
    } else {
      displaySnackbar({
        isOpen: true,
        severity: "info",
        autoHideDuration: 3000,
        message: kmMessages.info.document.not_selected,
      });
    }
  };

  const handleCloseUnsetPublicAccess = () => {
    setUnsetPublicAccessOpen(false);
  };

  const handleUnsetPublicAccess = () => {
    setUnsetPublicAccessOpen(false);
    enableGlobalLoader();
    apiPostRequest(
      apiEndpoints.setDocumentsPublicAccess.path,
      {
        nodeIds: selectedDocumentIds,
        action: "unset_public_access",
      },
      true
    )
      .then((data) => {
        setSelectedDocumentIds([]);
        setReloadCounter(reloadCounter + 1);
        disableGlobalLoader();
      })
      .catch((error) => {
        disableGlobalLoader();
        navigate("/dokumenty");
      });
  };

  const handleAttendance = (menuIndex) => {
    switch (menuIndex) {
      case 0:
        setCommitteeAttendanceStatus(
          "enable",
          "Mechanizm zbierania potwierdzeń uczestnictwa został włączony"
        );
        break;
      case 1:
        setCommitteeAttendanceStatus(
          "stop",
          "Mechanizm zbierania potwierdzeń uczestnictwa został wyłączony"
        );
        break;
      case 2:
        navigate(`/potwierdzeniaudzialu/${folderId}`);
        break;
      default:
        break;
    }
  };

  const setCommitteeAttendanceStatus = (status, successMessage) => {
    apiPutRequest(
      apiEndpoints.setCommitteeAttendanceStatus.path,
      {
        structNodeId: folderId,
        action: status,
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
        displaySnackbar({
          isOpen: true,
          severity: "success",
          autoHideDuration: 3000,
          message: successMessage,
        });
      })
      .catch((error) => {
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 3000,
          message: "Wystąpił błąd",
        });
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        }
      });
  };

  useEffect(() => {
    enableGlobalLoader();
    if (documentId) {
      setFoundDocuments([]);
      setSearchText("");
      setSearchTextInternal("");
      setAllDocumentsSearch(false);
      setContentSearch(false);
    }
    apiGetByIdRequest(
      documentId
        ? apiEndpoints.getDocumentsBySiblingId.path
        : apiEndpoints.getDocuments.path,
      documentId ? documentId : folderId ? folderId : "",
      true
    )
      .then((data) => {
        if (isMounted) {
          setDocuments(
            addCreatedUpdatedPublishedArchivedFields(
              data.documentStructNodes,
              "createdBy",
              "createdAt",
              "updatedBy",
              "updatedAt",
              "publishedBy",
              "publishedAt",
              ", "
            )
          );

          const { documentStructNodes, ...other } = data;
          setLevelDetails(other);
          setDocumentId(null);

          if (votingId) {
            setVotingDetails(
              findVotingDetailsInStructNodes(data.documentStructNodes)
            );
          } else {
            setVotingDetails(null);
          }
        }
        disableGlobalLoader();
      })
      .catch((error) => {
        if (error.response?.status === 403 && error.response.data) {
          if (error.response.data.code === "ERROR_NOT_ACCESS_PARENT") {
            // displaySnackbar({
            //   isOpen: true,
            //   severity: "error",
            //   autoHideDuration: 5000,
            //   message: "Brak dostępu do katalogu, nastąpiło przekierowanie do katalogu głównego",
            // });
            // navigate("/dokumenty");
            navigate("/nieuprawnionydostep");
          }
        } else if (error.response?.status === 401 && error.response.data) {
          if (error.response.data.code === "ERROR_UNAUTHORIZED") {
            setRedirectPath(sourcePath);
            navigate("/logowanie");
          }
        }
        disableGlobalLoader();
      });
    return () => {
      setDocuments([]);
    };
  }, [folderId, reloadCounter]);

  const handleConfirmButtonClick = (event, action) => {
    event.preventDefault();
    switch (action) {
      case "participation":
        setCommitteeConfirmation(
          action,
          "Potwierdzenie udziału zostało zarejestrowane"
        );
        break;
      case "no_participation":
        setCommitteeConfirmation(
          action,
          "Potwierdzenie braku udziału zostało zarejestrowane"
        );
        break;
      case "cancel":
        setCommitteeConfirmation(
          action,
          "Anulowano złożone potwierdzenie udziału"
        );
        break;
      default:
        break;
    }
  };

  const setCommitteeConfirmation = (action, successMessage) => {
    apiPutRequest(
      apiEndpoints.setCommitteeAttendanceConfirmation.path,
      {
        structNodeId: folderId,
        action: action,
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
        displaySnackbar({
          isOpen: true,
          severity: "success",
          autoHideDuration: 3000,
          message: successMessage,
        });
      })
      .catch((error) => {
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 3000,
          message: "Wystąpił błąd",
        });
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        }
      });
  };

  const handleChange = (value) => {
    setSearchTextInternal(value);
    if (!allDocumentsSearch && !contentSearch) {
      setSearchText(value);
    }
  };

  const toggleAllDocumentsSearch = () => {
    if (!allDocumentsSearch) {
      setSearchText("");
    }
    setAllDocumentsSearch((allDocumentsSearch) => !allDocumentsSearch);
  };

  const toggleContentSearch = () => {
    if (!contentSearch) {
      setSearchText("");
    }
    setContentSearch((contentSearch) => !contentSearch);
  };

  const searchBackFunction = () => {
    setSearchText("");
    setSearchTextInternal("");
    setFoundDocuments([]);
    setAllDocumentsSearch(false);
    setContentSearch(false);
  };

  const reloadSearch = (documentId) => {
    setDocumentId(documentId);
    setReloadCounter(reloadCounter + 1);
  };

  const searchDocuments = () => {
    if (searchTextInternal?.length > 0) {
      enableGlobalLoader();
      hideSnackbar();
      apiPostRequest(
        apiEndpoints.searchDocumentFiles.path,
        {
          searchWord: searchTextInternal,
          searchInAllNames: allDocumentsSearch,
          searchInContent: contentSearch,
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          if (data?.files.length > 0) {
            setFoundDocuments(data.files);
          } else {
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 5000,
              message: kmMessages.error.document.search_not_result,
            });
          }
        })
        .catch((error) => {
          disableGlobalLoader();
          displaySnackbar({
            isOpen: true,
            severity: "error",
            autoHideDuration: 3000,
            message: "Wystąpił błąd",
          });
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    }
  };

  const findVotingDetailsInStructNodes = (documentStructNodes) => {
    for (var documentStructNode of documentStructNodes) {
      if (documentStructNode.votings) {
        let votings = documentStructNode.votings.filter(
          (voting) => votingId == voting.id
        );
        if (votings?.length > 0) {
          return votings[0];
        }
      }
    }

    return null;
  };

  return (
    <Page className={classes.root} title="Dokumenty">
      <KmPageTitle>
        {levelDetails.structNodeName
          ? levelDetails.structNodeName === "root"
            ? "Katalog główny"
            : levelDetails.structNodeName
          : "Dokumenty"}
      </KmPageTitle>
      <Container maxWidth={false}>
        {userHasAtLeastOnePermission(globalData, [
          "user_admin",
          "super_admin",
        ]) ? (
          <Toolbar
            isAuthorized={globalData.currentUser.isAuthorized}
            parentFolderId={folderId ? folderId : 1}
            dialogHandler={handleClickOpen}
            publishHandler={handleClickOpenPublish}
            unpublishHandler={handleClickOpenUnpublish}
            setPublicAccessHandler={handleClickOpenSetPublicAccess}
            unsetPublicAccessHandler={handleClickOpenUnsetPublicAccess}
            attendanceHandler={handleAttendance}
            levelDetails={levelDetails}
            siblingId={
              selectedDocumentIds?.length === 1 ? selectedDocumentIds[0] : null
            }
            siblingName={
              selectedDocumentIds?.length === 1
                ? getSelectedDocumentName(selectedDocumentIds[0])
                : null
            }
            moveSelectedDocuments={getSelectedDocuments(selectedDocumentIds)}
          />
        ) : (
          <></>
        )}
        <Box mt={2}>
          <Box mb={1}>
            <Card>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item sm={4} xs={12}>
                    <Box>
                      <TextField
                        fullWidth={true}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SvgIcon fontSize="small" color="action">
                                <SearchIcon />
                              </SvgIcon>
                            </InputAdornment>
                          ),
                        }}
                        title="Wyszukaj"
                        placeholder="Wyszukaj"
                        helperText={
                          allDocumentsSearch || contentSearch
                            ? "Aby uruchomić wyszukiwanie, należy kliknąć przycisk SZUKAJ"
                            : ""
                        }
                        inputProps={{
                          title: "Wyszukaj",
                          "aria-label": "Wyszukaj",
                        }}
                        variant="standard"
                        value={searchTextInternal}
                        onChange={(e) => handleChange(e.target.value)}
                      />
                    </Box>
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <Box display="flex">
                      <FormControlLabel
                        value="alldocs"
                        control={
                          <Switch
                            color="primary"
                            checked={allDocumentsSearch}
                            onChange={toggleAllDocumentsSearch}
                          />
                        }
                        label="Wszystkie dokumenty"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="contentsearch"
                        control={
                          <Switch
                            color="primary"
                            checked={contentSearch}
                            onChange={toggleContentSearch}
                          />
                        }
                        label="Szukanie w treści"
                        labelPlacement="end"
                      />
                    </Box>
                  </Grid>
                  <Grid item sm={2} xs={12}>
                    {allDocumentsSearch || contentSearch ? (
                      <Box display="flex" justifyContent="flex-end">
                        <Button
                          disabled={!searchTextInternal}
                          variant="contained"
                          color="primary"
                          startIcon={<SearchIcon />}
                          onClick={searchDocuments}
                          fullWidth={true}
                        >
                          Szukaj
                        </Button>
                      </Box>
                    ) : (
                      <></>
                    )}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>
          {foundDocuments?.length > 0 ? (
            <KmDocumentList
              title={`Wyniki wyszukiwania dla hasła "${searchTextInternal}":`}
              backFunction={searchBackFunction}
              rows={foundDocuments}
              reloadView={reloadSearch}
            />
          ) : (
            <KmFilteredDocumentsTable
              levelDetails={levelDetails}
              isAuthorized={globalData.currentUser.isAuthorized}
              markable={
                globalData.currentUser.isAuthorized &&
                userHasAtLeastOnePermission(globalData, [
                  "user_admin",
                  "super_admin",
                ])
              }
              markVotings={true}
              votingDetails={votingDetails}
              headCells={headCells}
              rows={documents}
              onSelectedRowIdsChange={onSelectedDocumentIdsChanged}
              defaultOrder="asc"
              handleConfirmButtonClick={handleConfirmButtonClick}
              searchText={searchText}
            />
          )}
        </Box>
      </Container>
      <Dialog
        fullScreen={fullScreen}
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Usuwanie dokumentów i katalogów"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Czy na na pewno chcesz usunąć zaznaczone katalogi/dokumenty?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Nie
          </Button>
          <Button onClick={handleDelete} color="primary" autoFocus>
            Tak
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={dialogPublishOpen}
        onClose={handleClosePublish}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Publikowanie dokumentów i katalogów"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Czy na na pewno chcesz opublikować zaznaczone katalogi/dokumenty?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClosePublish} color="primary">
            Nie
          </Button>
          <Button onClick={handlePublish} color="primary" autoFocus>
            Tak
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={dialogUnpublishOpen}
        onClose={handleCloseUnpublish}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Cofnięcie publikacji dokumentów i katalogów"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Czy na na pewno chcesz cofnąć publikację zaznaczonych
            katalogów/dokumentów?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseUnpublish} color="primary">
            Nie
          </Button>
          <Button onClick={handleUnpublish} color="primary" autoFocus>
            Tak
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={dialogSetPublicAccessOpen}
        onClose={handleCloseSetPublicAccess}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Publikowanie dokumentów i katalogów"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Czy na pewno chcesz ustawić dostęp publiczny do zaznaczonych
            katalogów/dokumentów?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleCloseSetPublicAccess}
            color="primary"
          >
            Nie
          </Button>
          <Button onClick={handleSetPublicAccess} color="primary" autoFocus>
            Tak
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={dialogUnsetPublicAccessOpen}
        onClose={handleCloseUnsetPublicAccess}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Ustawienie dostępu po zalogowaniu do dokumentów i katalogów"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Czy na pewno chcesz ustawić dostęp po zalogowaniu do zaznaczonych
            katalogów/dokumentów?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleCloseUnsetPublicAccess}
            color="primary"
          >
            Nie
          </Button>
          <Button onClick={handleUnsetPublicAccess} color="primary" autoFocus>
            Tak
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  set: (documentData) => dispatch(actions.set(documentData)),
  enableGlobalLoader: () => dispatch(globalActions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(globalActions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(globalActions.displaySnackbar(snackBarParameters)),
  setRedirectPath: (redirectPath) =>
    dispatch(globalActions.setRedirectPath(redirectPath)),
  hideSnackbar: () => dispatch(globalActions.hideSnackbar()),
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentListView);
